<template>
	<div class="rounded bg-white shadow-card">
		<slot />
	</div>
</template>

<script lang="ts" setup></script>
